import React from 'react';

import { BadgeSize, BadgeVariant, StyledBadge } from './styles';

export type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  variant?: BadgeVariant;
  size?: BadgeSize;
  color?: string;
  backgroundColor?: string;
};

const Badge = ({
  variant = 'neutral',
  size = 'md',
  color,
  backgroundColor,
  children,
  ...rest
}: BadgeProps): JSX.Element => {
  return (
    <StyledBadge
      $variant={variant}
      $size={size}
      $color={color}
      $backgroundColor={backgroundColor}
      {...rest}
    >
      {children}
    </StyledBadge>
  );
};

export default Badge;
